import React from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import PromptGenerator from './pages/PromptGenerator';
import Diagnostics from './pages/Diagnostics';
import Instructions from './pages/Instructions';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PromptGenerator />} />
        <Route path="/prompt-generator" element={<PromptGenerator />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/diagnostics" element={<Diagnostics />} />
      </Routes>
    </Router>
  );
}

export default App;